var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.static)?_c('animated-number',{attrs:{"duration":200,"value":_vm.value,"formatValue":_vm.valueReadable}}):_c('span',{domProps:{"textContent":_vm._s(_vm.formattedValue)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }